export { useHasEarnedLoyaltyPoints } from './useHasEarnedLoyaltyPoints';
